import { MappableModel } from './mappable-model'
import { Variation } from './variation'
import { Mapper } from '../services/mapper.service'

export class Item extends MappableModel {
  public id: number
  public uuid: string
  public name: string
  public description: number
  public vendor: string
  public shippable: boolean
  public visible: boolean
  public position: number
  public store_id: number
  public default_variation_id: number
  public background_check_required: boolean
  public variations: Variation[]

  public deserialize() {
    this.variations = Mapper.asArray<Variation>(this.variations, Variation)
  }
}
